import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class CarTypeService {


  static getCarType(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getCarType}?id=${item?.id}`
      }
      else
      if(item?.range){
        api= `${API_BASE_URL}${API_PATHS.getCarType}?range=${item?.range}`
     } else{
      api = `${API_BASE_URL}${API_PATHS.getCarType}?limit=${item?.limit}`;
      }
      return axiosInstance
          .get(api)
          
  }


  static getCarTypeRange(item) {
  
    let api = '';
    if(item?.id){
       api= `${API_BASE_URL}${API_PATHS.getCarTypeRange}?id=${item?.id}`
    }
   else{
    api = `${API_BASE_URL}${API_PATHS.getCarTypeRange}?limit=${item?.limit}`;
    }
    return axiosInstance
        .get(api)
        
}

  
static addCarType(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addCarType}`;
    return axiosInstance
        .post(api,item)
        
}

static editCarType(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editCarType}`;
    return axiosInstance
        .put(api,item)
        
}

static deleteCarType(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deleteCarType}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deleteCarType}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default CarTypeService;